<template>
  <div class="language-bar">
    <div class="language-button" @click="() => changeLocale('nl')">
      <div v-if="getLocale == 'nl'" class="language-button-check">
        <BaseIcon multiplatform icon="lang-checkbox" size="14px" />
      </div>
      <BaseIcon icon="lang-nl" size="100%" />
    </div>

    <div class="language-button" @click="() => changeLocale('en')">
      <div v-if="getLocale == 'en'" class="language-button-check">
        <BaseIcon multiplatform icon="lang-checkbox" size="14px" />
      </div>
      <BaseIcon icon="lang-en" size="100%" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    addSpacer: Boolean
  },
  computed: {
    ...mapGetters(["getLocale"])
  },
  methods: {
    changeLocale(locale) {
      this.$store.commit(this.$mutations.SET_LOCALE, locale);
      document.documentElement.lang = locale;
    }
  }
};
</script>

<style lang="scss" scoped>
.language-bar {
  display: flex;
  justify-content: center;
  height: 45px;
  margin-top: 10px;
  width: 100%;

  .language-button {
    margin: 0 16px;
    padding: 6px 6px 0 6px;
    position: relative;

    &:hover {
      cursor: pointer;
    }

    &-check {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
    }
  }
}

.languages-center-spacer {
  display: inline-block;
  width: 47px;
}
</style>
